
import { slideUp } from './app.js'
import { slideDown } from './app.js'
import { slideToggle } from './app.js'

// --- Select ---

// Create selects

document.querySelectorAll('select').forEach(function(node) {
  node.classList.add('base-select')
  let mySelectedOptions = node.selectedOptions

  let optionsTable = [],
      optionSelected = 0,
      optionDisabled = 0

  // Add all option to the table
  node.querySelectorAll('option').forEach(function(node2) {
    for (let i = 0; i < mySelectedOptions.length; ++i) {
      if (node2 == mySelectedOptions[i]) {
        optionSelected = 1
        break
      } else {
        optionSelected = 0
      }
    }
    if(node2.disabled){
      optionDisabled = 1
    } else {
      optionDisabled = 0
    }
    optionsTable.push({ value: node2.value, text: node2.textContent, selected: optionSelected, disabled: optionDisabled })
  })

  // Create a new selectyummy

  let newSelectDiv = document.createElement('div'),
      newSelectButton = document.createElement('button'),
      newSelectUl = document.createElement('ul')
  newSelectDiv.classList.add('selectyummy')
  newSelectButton.classList.add('selectyummy-select')
  newSelectUl.classList.add('selectyummy-options')
  newSelectDiv.appendChild(newSelectButton)
  newSelectDiv.appendChild(newSelectUl)
  node.after(newSelectDiv)
  if (node.multiple){
    newSelectDiv.classList.add('selectyummy-multiple')
  }

  // Add options to selectyummy
  let selectedOption = false,
      selectString = ''
  for(let i=0; i < optionsTable.length; ++i){
    let optionClass= '',
        newOption = document.createElement('li')

    // Selected option
    if(optionsTable[i].selected){
      newOption.classList.add('active')
      selectedOption = true
      if(selectString != '') {
        selectString = selectString + ', '
      }
      selectString = selectString + optionsTable[i].text
      newSelectButton.textContent = selectString
      newSelectButton.classList.remove('with-placeholder')

    // No selected options and a placeholder
    } else if (node.getAttribute('placeholder') && (optionsTable[0].text == '' || node.multiple) && (! selectedOption || optionsTable[0].selected)) {
      newSelectButton.textContent = node.getAttribute('placeholder')
      newSelectButton.classList.add('with-placeholder')
    }

    // Disabled option
    if (optionsTable[i].disabled){
      newOption.classList.add('disabled')
    }

    newOption.setAttribute('data-value', optionsTable[i].value)
    newOption.textContent = optionsTable[i].text
    newSelectUl.appendChild(newOption)
  }

  // If you want to block the selectyummy's width - use this line:
  // newSelectDiv.style.width = newSelectDiv.innerWidth + 'px'
})

// Click a select

document.querySelectorAll('.selectyummy-select').forEach(function(node) {
  node.addEventListener('click', function(e) {
    e.preventDefault()
    slideToggle(node.nextElementSibling)
    node.parentElement.classList.toggle('active')
  })
})

// Select changer

document.querySelectorAll('.base-select').forEach(function(node) {
  node.addEventListener('change', function(e) {
    let mySelectYummy = node.nextElementSibling,
        baseSelect = node

    // Single select activates clicked options
    if (! mySelectYummy.classList.contains('selectyummy-multiple')){
      let activeOption = mySelectYummy.querySelector('li[data-value="' + baseSelect.value + '"]')
      mySelectYummy.querySelectorAll('.selectyummy-options li').forEach(function(node1) {
        node1.classList.remove('active')
      })
      activeOption.classList.add('active')
      mySelectYummy.querySelector('.selectyummy-select').textContent = activeOption.textContent
      mySelectYummy.querySelector('.selectyummy-select').classList.remove('with-placeholder')
      if (baseSelect.getAttribute('placeholder') && activeOption.textContent == ''){
        mySelectYummy.querySelector('.selectyummy-select').textContent = baseSelect.getAttribute('placeholder')
        mySelectYummy.querySelector('.selectyummy-select').classList.add('with-placeholder')
      }

    // Multiple select adds option name to the list
    } else {
      mySelectYummy.querySelectorAll('.selectyummy-options li').forEach(function(node1) {
        node1.classList.remove('active')
      })
      let optionsSelected = []
      for (let i = 0; i < baseSelect.options.length; ++i) {
        if (baseSelect.options[i].selected) {
          optionsSelected.push(baseSelect.options[i].value || baseSelect.options[i].text)
        }
      }
      for (let i = 0; i < optionsSelected.length; ++i) {
        let clicked = mySelectYummy.querySelector('li[data-value="' + optionsSelected[i] + '"]').classList.add('active')
      }
      let selectString = ''

      mySelectYummy.querySelectorAll('.selectyummy-options li').forEach(function(selectOption) {
        if(selectOption.classList.contains('active')){
          if(selectString != '') {
            selectString = selectString + ', '
          }
          selectString = selectString + selectOption.textContent
        }
      })

      mySelectYummy.querySelector('.selectyummy-select').textContent = selectString
      mySelectYummy.querySelector('.selectyummy-select').classList.remove('with-placeholder')
      if (baseSelect.getAttribute('placeholder') && selectString == ''){
        mySelectYummy.querySelector('.selectyummy-select').textContent = baseSelect.getAttribute('placeholder')
        mySelectYummy.querySelector('.selectyummy-select').classList.add('with-placeholder')
      }
    }
  })
})

// Click a dropdown item

document.querySelectorAll('.selectyummy-options li').forEach(function(node) {
  node.addEventListener('click', function(e) {
    let mySelectYummy = node.closest('.selectyummy'),
        myBaseSelect = mySelectYummy.previousElementSibling

    if(! mySelectYummy.classList.contains('selectyummy-multiple')){
      myBaseSelect.value = this.getAttribute('data-value')
      // Single selects should close when the option is clicked
      slideUp(mySelectYummy.querySelector('.selectyummy-options'))
      mySelectYummy.classList.remove('active')
    } else {
      if (myBaseSelect.querySelector('option[value="' + node.getAttribute('data-value') + '"]').selected == false) {
        myBaseSelect.querySelector('option[value="' + node.getAttribute('data-value') + '"]').selected = true
      } else {
        myBaseSelect.querySelector('option[value="' + node.getAttribute('data-value') + '"]').selected = false
      }
    }

    if ('createEvent' in document) {
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('change', false, true)
      myBaseSelect.dispatchEvent(evt)
    }
    else {
      myBaseSelect.fireEvent('onchange')
    }
  })
})

// Hide dropdown when we clicked outside

document.addEventListener('mouseup', function(e){
  let selectContainer = document.querySelector('.selectyummy.active')
  if (selectContainer) {
    let me = e.target,
        myParents = []
    while (me) {
      myParents.unshift(me)
      me = me.parentNode
    }
    if (selectContainer != e.target && ! myParents.includes(selectContainer)){
      slideUp(selectContainer.querySelector('.selectyummy-options'))
      selectContainer.classList.remove('active')
    }
  }
})

// Keyboard

document.addEventListener('keydown', function(e){
  let selectContainer = document.querySelector('.selectyummy.active')
  if ((e.keyCode === 40 || e.keyCode === 38) && selectContainer) { // Down or Up
    e.preventDefault()
    let me = document.querySelector('.selectyummy.active'),
        currentHoveredOption = me.querySelector('.selectyummy-options li.hover'),
        newHoveredOption,
        options = me.querySelectorAll('.selectyummy-options li:not(.disabled)')

    // The last and first element
    if (! currentHoveredOption) {
      if (e.keyCode === 40) { // down
        newHoveredOption = options[0]
      } else { // up
        newHoveredOption = options[options.length - 1]
      }

    // Use keys to go to the option
    } else {
      if (e.keyCode === 40) { // down
        while (currentHoveredOption) {
          if (currentHoveredOption.nextElementSibling) {
              if (currentHoveredOption.nextElementSibling.classList.contains('disabled')) {
                currentHoveredOption = currentHoveredOption.nextElementSibling
              } else {
                newHoveredOption = currentHoveredOption.nextElementSibling
                break
              }
          } else {
            newHoveredOption = options[0]
            break
          }
        }
      } else { // up
        while (currentHoveredOption) {
          if (currentHoveredOption.previousElementSibling) {
              if (currentHoveredOption.previousElementSibling.classList.contains('disabled')) {
                currentHoveredOption = currentHoveredOption.previousElementSibling
              } else {
                newHoveredOption = currentHoveredOption.previousElementSibling
                break
              }
          } else {
            newHoveredOption = options[options.length - 1]
            break
          }
        }
      }

      me.querySelector('.selectyummy-options li.hover').classList.remove('hover')
    }

    // Hover the option
    newHoveredOption.classList.add('hover')

    // Scroll the box to the option so we can see everything
    let offset = newHoveredOption.offsetTop
    me.querySelector('.selectyummy-options').scroll({
      top: offset,
      left: 0,
      behavior: 'smooth'
    })
  }

  if (e.keyCode === 13 && selectContainer) { // Enter
    // When option is hovered, Enter will click it
    e.preventDefault()
    document.querySelector('.selectyummy.active .selectyummy-options li.hover').click()
  }

  if (e.keyCode === 9 && selectContainer) { // Tab
    // When selectyummy is opened, tab closes and deactivates it
    slideUp(document.querySelector('.selectyummy.active .selectyummy-options'))
    document.querySelector('.selectyummy.active').classList.remove('active')
  }
})

// Reset the 'hover' class (needed for keyboard) when we truly hover another element

document.querySelectorAll('.selectyummy.active .selectyummy-options li').forEach(function(node) {
  node.addEventListener('mouseenter', function(e) {
    document.querySelector('.selectyummy.active .selectyummy-options li.hover').classList.remove('hover')
  })
})
